import { useFindAllActivities } from "~/gen/api"
import { useFindOperationChainsQuery } from "~/pages/Admin/Ingestion/OpChains/hooks/useFindOperationChainsQuery"

export function useOpChainsQueries() {
  const {
    data: activities,
    isPending: activitiesLoading,
    isError: activitiesError,
  } = useFindAllActivities()
  const {
    data: opChains,
    isPending: opChainLoading,
    isError: opChainError,
  } = useFindOperationChainsQuery({})

  if (activitiesLoading || opChainLoading) {
    return { isLoading: true }
  }

  if (activitiesError || opChainError) {
    return { isError: true }
  }

  return { activities, opChains }
}
